<template>
  <section style="position:relative" id="section">
    <el-row class="statusRow">
    	<el-col  style="margin-bottom: 10px;">
	      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
	      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
	      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
	      <el-input
		        @clear="getList"
		        @keyup.enter.native="search"
		        ref="input"
		        class="search  xs24"
		        v-model="pdata.kw"
		        clearable
		        placeholder="请输入APPID/产品名称"
		        :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
		      >
		    </el-input>
	    	<el-select class="xs24" v-model="pdata.company_id" filterable  clearable placeholder="请选择关联公司">
	        <el-option v-for="(item,i) in selectBillCompanyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
	      </el-select>
	      <el-select class="xs24" v-model="pdata.source" filterable  clearable placeholder="请选择来源">
	        <el-option v-for="(item,i) in sources" :key="item.value" :label="item.name" :value="item.value"></el-option>
	      </el-select>
   		<el-button class="xs24" type="primary" id="seven" plain @click="changeDate(1)">昨天</el-button>
      <el-button class="xs24" type="primary" plain @click="changeDate(7)">最近7天</el-button>
      <el-date-picker
      	class="xs24"
        v-model="dateVal"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="今天"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-button size="medium" type="primary" @click="batchAddProduct">导入</el-button>
      <el-button size="medium" type="primary" @click="batchExportProduct">导出</el-button>
      <el-button size="medium" type="text" @click="downloadTemp">导入模板下载</el-button>
  
      </el-col>
		
           
		 
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width: 1200px;"
      stripe
      row-key="id"
      @selection-change="select"
      class="mytable"
      @sort-change="tableSort"
    >
    	
      <el-table-column type="selection" min-width="30px"></el-table-column>
      <el-table-column prop="id" fixed label="ID" min-width="50px" align="center"></el-table-column>
      <!--
      <el-table-column prop="icon" fixed="left" label="图标" min-width="85px" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.icon" alt class="gameIcon">
        </template>
      </el-table-column>-->
      <el-table-column prop="name" label="广告主游戏名称" align="center" class-name="noOver"  >
        <template slot-scope="scope" class="noOver">
        	<div @mousemove="showGN($event,scope.row)" @mouseleave="hideGN($event,scope.row,scope.$index)" style="position: relative;">
        		
        		<el-button type="text" @click="editProduct(scope.row)"  >{{scope.row.name}}</el-button>
        		<div role="tooltip" v-if="scope.row.data&&scope.row.data.length>0&&scope.row.show"  aria-hidden="false" class="el-popover el-popper" tabindex="0" style="width: 800px; position:absolute; left: 100px; top: 5px; transform-origin: center top; z-index: 2003;" x-placement="bottom-start">
							<!---->
							<table class="poptable" border="1" cellspacing="0" cellpadding="0" style="width: 100%; text-align: center;" >
								 <colgroup>
								 	<col width="20%" />
								 	<col width="20%" />
								 	<col width="60%" />
								 </colgroup>
								<tr><th>投放</th><th>投放位置</th><th>投放</th></tr>
								<tr v-for="item,index in scope.row.data">
									<td>{{index+1}}</td>
									<td >{{item.placement_name}}</td>
									<td><span style="cursor:copy;" v-if="item.path" class="blue" v-clipboard:copy="item.path" v-clipboard:success="onCopy" v-clipboard:error="onError">路径:{{item.path}}</span></td></tr>
								
							</table>
	
					  
						<div x-arrow="" class="popper__arrow" style="left: 8px;"></div>
				</div>
          
        	</div>
          
        </template>
      </el-table-column>
      <el-table-column prop="source" label="产品来源"align="center">
      	<template slot-scope="scope"> 
      		<span v-if="scope.row.source=='1'">互导 </span>
      		<span v-else-if="scope.row.source=='2'">卖量</span>
      		<span v-else-if="scope.row.source=='3'">测量</span>
      	</template>
      </el-table-column>
      <el-table-column prop="appid" label="APPID"  align="center"  min-width="90px"></el-table-column>
      <el-table-column prop="company_name" label="公司" align="center" min-width="150px;"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center" sortable="custom" min-width="110px"></el-table-column>
      <el-table-column prop="update_time" label="	更新时间" align="center"  sortable="custom" min-width="110px"></el-table-column>
      <el-table-column prop="status" label="	产品状态" align="center"  sortable="custom">
      	<template slot-scope="scope">
      		<span>{{scope.row.status=='1'?'正常':'禁用'}}</span>
      		<span v-if="scope.row._status.count!=scope.row._status.ok&&scope.row.status=='1'" class="red">{{scope.row._status.ok}}/{{scope.row._status.count}} </span>
      	</template>
      	
      </el-table-column>
      <el-table-column prop="placement" label="	操作" align="center" min-width="120px;">
      	<template slot-scope="scope">
      		 <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
          <el-button type="text"  @click="$router.push({name:'产品日志',params:{index_id:scope.row.id},query:{type:'product'}})">更新日志</el-button>
       </template>
      </el-table-column>
      
    </el-table>
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>

    <el-dialog
      :title="isAdd?'新增广告主游戏':'编辑广告主游戏'"
      :visible.sync="editDialog"
      top="5vh"
      width="700px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	 <el-form-item label="产品名称" prop="name" >
      	 		<el-row  :gutter="5" style="margin:0;">
      	 				<el-col :span="12" > 	
          				<el-input v-model="chooseProduct.name" placeholder="请输入产品名称" class="input" clearable></el-input>
          			</el-col>
          		
          	</el-row>		
        </el-form-item>
         <el-form-item label="产品来源" prop="source">
         	<!--<el-radio-group v-model="item.has_path" @change="hasPathChange(index)">
	            <el-radio  label="1" key="1" >有</el-radio>
	            <el-radio  label="0" key="0" >无</el-radio>
			    </el-radio-group>-->
          <el-radio-group v-model="chooseProduct.source ">
            <el-radio v-for="(item,index) in sources" :label="item.value" :key="item.value" :value="item.value">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="APPID" prop="appid" >
        	<el-row  :gutter="5" style="margin:0;">
      	 				<el-col :span="12" > 	
          					<el-input v-model="chooseProduct.appid" placeholder="请输入产品appid" class="input" clearable></el-input>
          			</el-col>
          		
          	</el-row>		
        </el-form-item>
        <el-form-item label="关联公司" prop="company_id" >
        	 <el-select v-model="chooseProduct.company_id" filterable  clearable placeholder="请选择关联公司">
            <el-option v-for="(item,i) in selectBillCompanyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="是否采集" prop="wx_collect" >
        		<el-radio-group v-model="chooseProduct.wx_collect">
				            <el-radio  label="1" key="1" >是</el-radio>
				            <el-radio  label="0" key="0" >否</el-radio>
			      </el-radio-group>
        </el-form-item>
        
        <el-form-item label="采集字段" prop="wx_collect" v-if="chooseProduct.wx_collect==1" >
        		<el-radio-group v-model="chooseProduct.wx_type">
				            <el-radio  label="1000091" key="1000091" >新增</el-radio>
				            <el-radio  label="1000088" key="1000088" >活跃</el-radio>
			      </el-radio-group>
        </el-form-item>
        
         <el-form-item label="投放" prop="data" v-for="(item,index) in chooseProduct.data">
         		<el-row  :gutter="5" style="margin:0;">
         			
         			 <el-col :span="22" style="margin:0  0 10px 0;"> 	
         			 	 有无路径：
         			 	<el-radio-group v-model="item.has_path" @change="hasPathChange(index)">
			            <el-radio  label="1" key="1" >有</el-radio>
			            <el-radio  label="0" key="0" >无</el-radio>
			          </el-radio-group>
         			 </el-col>
         			
         			 	<el-col :span="2">
								 	<div class="grid-content bg-purple-light" style="font-size: 24px; cursor: pointer;"> 
								 		<i class="el-icon-circle-plus"  @click="addPlacement(index)"></i> 
								 		<!--<i class="el-icon-remove" v-if="chooseProduct.data.length>1"  @click="removePlacement(index)"></i>-->
								 	</div>
								</el-col>
								<el-col :span="24" style="margin:0  0 10px 0;" v-if="chooseProduct.source==2">
         			 	  是否换量：
         			 		<el-radio-group v-model="item.exchange">
				            <el-radio  label="1" key="1" >是</el-radio>
				            <el-radio  label="0" key="0" >否</el-radio>
			          	</el-radio-group>
         			 	
         			  </el-col>
								
         			 <el-col :span="20"  style="margin:0  0 10px 0;">
         			 		<el-input :disabled="item.has_path==1?false:true" v-model="item.path" placeholder="请输入路径" class="input" clearable style="width:100%;"></el-input>
         			 </el-col>
         			 <el-col :span="4"  style="margin:0  0 10px 0;">
     			 				<el-switch
									  v-model="item.status"
									  active-color="#13ce66"
									  @change="statusChange(index)"
									  inactive-color="#f2f2f2">
									</el-switch>
         			 </el-col>
         			 <el-col :span="8">
				          <el-select v-model="item.placement_id " :disabled="item.isnew==true?false:true" filterable  clearable placeholder="请选择投放位置">
				            <el-option label="请选择投放位置" value=""></el-option>
				            <el-option v-for="(item,i) in option" :key="item.issued_app_id" :label="item.name" :value="item.issued_app_id"></el-option>
				          </el-select>
         			 </el-col>
         			 <el-col :span="8">
     			 				<el-select v-model="item.type " filterable  clearable placeholder="请选择计价方式">
				            <el-option  key="cps" label="cps" value="cps"></el-option>
				            <el-option  key="cpa" label="cpa" value="cpa"></el-option>
				            <el-option  key="uv" label="uv" value="uv"></el-option>
				         </el-select>
         			 </el-col>
         			 <el-col :span="8">
         			 		<el-input v-model="item.unit" placeholder="请输入计价单价" class="input" clearable style="width:100%;"></el-input>
         			 </el-col>
         		</el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
    
    
      <el-dialog title="批量增加" :visible.sync="batchDialog" width="950px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">

				
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				 :headers="headers"
				  :on-success="batchSuccess"
				  name="file"
				  :show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
       
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips}}</el-col>
      </el-row>



       <el-row :gutter="5" v-for="item,index in batchForm" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0">
       		<el-col  :span="3" v-for="(citem,idx) in  item" v-if="idx!=4">
       				{{citem==''?'&nbsp;':citem}}
       		</el-col>	
       		
       </el-row>
      


      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
        <el-button @click="batchCalcel">取 消</el-button>
        <el-button type="primary" @click="batchSubmit" v-if="this.batchTips=='导入预览'">确 定</el-button>
       
      </div>
    </el-dialog>
    
    	
    
    
  </section>
</template>

<script>
import { splist, saddp, spstatus, splog, seditp, scopy ,selectBillCompany,getPlacementList,getPlistByID,baseUrl,PostBitchAddProduct,getBitchProductExport,checkProduct} from "../api/api";
import UploadImg from "./uploadImg.vue";

export default {
  components: {
    UploadImg
  },
  data() {
  	var validatename= (rule, value, callback) => {
    	  if(value===''){
    	  	rule.message='请输入产品名称';
    	  	callback(new Error());
    	  }
    	  else{
    	  	var p = {'kw':value,'index_id':this.chooseProduct.index_id};
    	  	checkProduct(p, this.$cookie.getCookie("login")).then(response => {
			        if (response.code == 200) {
			        	callback();
			        }
			        else{
			        	rule.message=response.msg;
			        	callback(new Error());
			        }
		        })
    	  }
      };
    var validateappid= (rule, value, callback) => {
    	  if(value===''){
    	  	rule.message='请输入产品appid';
    	  	callback(new Error());
    	  }
    	  else{
    	  	
    	  	var p = {'kw':value,'index_id':this.chooseProduct.index_id};
    	  	checkProduct(p, this.$cookie.getCookie("login")).then(response => {
			        if (response.code == 200) {
			        	callback();
			        }
			        else{
			        	rule.message=response.msg;
			        	callback(new Error());
			        }
		        })
    	  }
      };
    return {
      rules: {
        name: [{  validator: validatename, message: "请输入产品名称", trigger: "blur" }],
        appid: [{  validator: validateappid, message: "请输入产品appid", trigger: "blur" }],
        source:[{required: true, message: "请选择产品来源", trigger: "blur" }],
        company_id:[{required: true, message: "请选择公司", trigger: "blur" }],
        data:[{required: true, message: "请选择投放", trigger: "blur" }],
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        company_id:'',
        kw: "",
        sort_field: "",
        sort_by: "",
         sdate:'',
        edate:'',
        source:'',
      },
      dateVal: [
        '',
        ''
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      plist: [],
      selectBillCompanyList:[],
      maxPage: 1,
      config: [],
      tags: [],
      sources:[],
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "110px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,


      tText: "请选择产品题材",
      pText:"请选择产品投放位置",
 

  

      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      option: [], //投放位置配置
      batchDialog:false,
   		batchForm:[],
			batchTips:'导入预览',
			url:baseUrl+"Product/preview",
			headers:{
          'token':this.$cookie.getCookie("login")
      },
      form: {
      },
      gnTxt:{
      	data:[],
      	show:false,
      	left:0,
      	top:0,
      },
    };

  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    },
    'pdata.company_id': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'pdata.sort_by': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'pdata.source':{
    	 handler(n, o) {
    	 	
        this.getList();
      },
      deep: true
    }
  },
  methods: {
  	downloadTemp(){
  		window.location.href='/static/sdk_v2.0_import.csv';
  	},
  	tableSort(e){
  		
  			this.pdata.sort_field=e.prop;
  			if(e.order=="ascending"){
  				this.pdata.sort_by="asc"
  				
  			}
  			else if(e.order=="descending"){
  				this.pdata.sort_by="desc"
  			}
  			else{
  				this.pdata.sort_by="";
  				this.pdata.sort_field="";
  			}
  		
  		
  	},
  	 onCopy(){
  	  	this.$message({
          message: '复制成功',
          type: 'success'
       });
  	  },
  	  onError(){
  	  	this.$message({
          message: '复制失败',
          type: 'warning'
       });
  	  },
  	showGN(e,s){
  		
  		if(s.data&&s.data.length>0){
  			s.show=true;
//			this.gnTxt={
//			data:s.data,
//    	show:true,
//    	left:e.pageX,
//    	top:e.pageY,
//			}
  		}

  		
  			//console.log(this.gnTxt);
  	},
  	hideGN(e,s,i,k){
  		s.show=false;

  	},
  	batchSuccess(response, file, fileList){

  		if(response.code==200){
  			this.batchForm=response.data;
  		}
  		
  		
  	},
  	 //批量增加
  	batchAddProduct(){
  		this.batchDialog=true;
  	},
  	batchCalcel(){
    	this.batchDialog = false;
    	this.batchForm=[];
    	this.batchTips="导入预览"
    },
    batchSubmit(){
      PostBitchAddProduct(this.batchForm, this.$cookie.getCookie("login")).then(response => {
        if (response.code == 200) {
         	 if(response.data.length>0){
         	 	 
        			this.batchForm=response.data;
        			this.batchTips="以下数据未成功导入";
        			
        			
         	 }
         	 else{
         	 	 this.$message({ message: "导入成功", type: "success" });
         	 	 this.batchDialog = false;
         	 	 this.batchForm=[];
         	 	 this.getList();
         	 }
        }
        else{
        	this.$message.error('导入失败');
        	 
        }
     });
    },
    batchExportProduct(){
    	getBitchProductExport('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
	        var that = this;
		      var arr = [];
		
		      var arrHd = ["产品名称","appid", "公司名称", "投放渠道", "投放路径"];
		      var arrFval = ["product_name","appid","company_name","placement_name", "path"];
	
	     
	      console.log(res.data);
	      if (res.data == null||res.data.length==0) {
	        return false;
	      }
	
	      console.log(arrHd);
	      console.log(arrFval);
	      require.ensure([], () => {
	        const {
	          export_json_to_excel,
	          export_table_to_excel
	        } = require("../vendor/Export2Excel.js");
	        const tHeader = arrHd;
	        const filterVal = arrFval;
	        const list = res.data;
	
	        const data = this.formatJson(filterVal, list);
	        export_json_to_excel(
	          tHeader,
	          data,
	          "导出产品列表"
	        );
	          
	      })
      }
    })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  	addPlacement(index){
  		var o={exchange:"0",has_path:"1",path:"",type:"",unit:"",placement_id:"",status:true,isnew:true};
			this.chooseProduct.data.push(o);
			this.$forceUpdate();
  	},
  	removePlacement(index){
  		this.chooseProduct.data.splice(index,1); 
  		this.$forceUpdate();
  	},
  	hasPathChange(index){
  		if(this.chooseProduct.data[index].has_path==0){
  			this.chooseProduct.data[index].path="";
  		}
  	},
  	statusChange(index){
  		console.log('change');
  	},
  	changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
  	
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      splist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		res.data.list.forEach((v,i)=>{
        			v.show=false;
        		})
        		 this.plist = res.data.list;
        	}
        	else{
        		this.plist=[];
        	}
         this.maxPage = res.data.max_page;
        }
      });
      selectBillCompany('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.selectBillCompanyList = res.data.list;

        }
      });
      getPlacementList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
       		
          this.option = res.data.list;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
      //  this.option = this.$store.config.product_placement;
        this.sources=[{name:"互导",value:"1"},{name:"卖量",value:"2"},{name:"测量",value:"3"}];
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },


    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct(d) {
    	var p="index_id="+d.id;
    	getPlistByID(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.data&&res.data.data.length>0){
        		res.data.data.forEach((v,i)=>{
        			if(v.status==1){
        				v.status=true;
        			}
        			else{
        				v.status=false;
        			}
        		})
        	}
        	this.chooseProduct = res.data;
        	this.chooseProduct.index_id=res.data.id;
        	delete this.chooseProduct.id;
        	if(!res.data.data){
        		this.chooseProduct.data=[{has_path:"1",path:"",type:"",unit:"",placement_id:"",status:true}];
        	}
        }
        	
      });
     
      this.editDialog = true;
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
    	
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      
      this.$confirm(this.cP.status==1?'启用产品需二次确认, 是否继续?':'禁用产品需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            	
      spstatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
     })
    },
    addProduct() {
      this.chooseProduct = {
        name: "",
        source:"1",
        appid: "",
        company_id:"",
        wx_collect:"0",
        wx_type:"",
      	data:[{exchange:"0",has_path:"1",path:"",type:"",unit:"",placement_id:"",status:true,isnew:true}]
      };
      this.editDialog = true;
      this.isAdd = true;
    },
    submit() {

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
        	for(var i=0;i<this.chooseProduct.data.length;i++){
        		if(this.chooseProduct.data[i].placement_id==''){
        			this.$message.error('投放位置不能为空');
        			return false;
        		}
        		if(this.chooseProduct.data[i].type==''){
        			this.$message.error('计价方式不能为空');
        			return false;
        		}
        		if(this.chooseProduct.data[i].unit==''){
        			this.$message.error('计价单位不能为空');
        			return false;
        		}
        		if(this.chooseProduct.data[i].has_path==1&&this.chooseProduct.data[i].path==''){
        			this.$message.error('选择投放路径后，投放路径不能为空');
        			return false;
        		}
        	}

        	if(this.chooseProduct.data.length>0){
        			this.chooseProduct.data.forEach((v,i)=>{
        				if(v.status==true){
          				v.status=1
          			}
          			else{
          				v.status=0
          			}
        			})
          	}
        	
          
          if (this.isAdd) {
            saddp(this.chooseProduct, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
//          this.$prompt("请输入编辑原因", "提示", {
//            confirmButtonText: "确定",
//            cancelButtonText: "取消",
//            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
//            inputErrorMessage: "内容不能为空"
//          }).then(({ value }) => {
//            this.chooseProduct.log = value;
              seditp(this.chooseProduct, this.$cookie.getCookie("login")).then(
                res => {
                  if (res.code == 200) {
                    this.getList();
                    this.editDialog = false;
                  } else {
                    this.$message.error(res.msg);
                  }
                }
              );
//          });
          }
        } else {
          return false;
        }
      });
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted() {
    this.getList();
    this.getConfig();
  }
};
</script>
<style scoped lang="scss">

.blue{
	color: #0082E6;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
</style>

<style>
.el-table .poptable{
	border: 1px solid #F2F2F2;
}
.el-table .poptable th,.el-table .poptable td{
	text-align:center;
	border: 1px solid #F2F2F2;
}
	.el-table.mytable{
		overflow: inherit;
	}
	.mytable .el-table__body-wrapper{
		overflow: inherit;
}
.el-table .noOver .cell{
	overflow:inherit;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
	.total{
		min-width: 100% !important;
	}
	.xs24{
		width: 100% !important;
		margin: 5px 0;
	}
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 60px;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// Plist.vue?7f537050